/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideCircleIcon20Solid = forwardRef('DivideCircleIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM6 9a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H6Zm5.248-2.752a1.248 1.248 0 1 1-2.496 0 1.248 1.248 0 0 1 2.496 0ZM10 14.996a1.248 1.248 0 1 0 0-2.496 1.248 1.248 0 0 0 0 2.496Z" })));
});
